/**
 * Dates calendaires YYYY-MM-DD (UTC). Ne pas utiliser `new Date(y, m, d)` :
 * les années 0–99 sont remappées vers 1900–1999 (ex. 0002-08-31 → 1902).
 */

export const DATE_YEAR_MIN = 2020;
export const DATE_YEAR_MAX = 2100;

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function isPlausibleIsoDate(value: string): boolean {
  const m = ISO_DAY.exec(value.trim());
  if (!m) return false;
  const y = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (y < DATE_YEAR_MIN || y > DATE_YEAR_MAX) return false;
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;
  const dt = new Date(`${m[1]}-${m[2]}-${m[3]}T00:00:00Z`);
  if (Number.isNaN(dt.getTime())) return false;
  return (
    dt.getUTCFullYear() === y && dt.getUTCMonth() === month - 1 && dt.getUTCDate() === day
  );
}

/** Retourne null si la date n'est pas une journée calendaire 2020–2100. */
export function addCalendarDays(isoDate: string, days: number): string | null {
  if (!isPlausibleIsoDate(isoDate)) return null;
  const dt = new Date(`${isoDate}T00:00:00Z`);
  dt.setUTCDate(dt.getUTCDate() + days);
  const y = dt.getUTCFullYear();
  const mo = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const d = String(dt.getUTCDate()).padStart(2, "0");
  const out = `${y}-${mo}-${d}`;
  return isPlausibleIsoDate(out) ? out : null;
}

/** Si les deux dates sont renseignées : fin >= début (YYYY-MM-DD comparable). */
export function isEndOnOrAfterStart(startsOn: string, endsOn: string): boolean {
  if (!startsOn.trim() || !endsOn.trim()) return true;
  if (!isPlausibleIsoDate(startsOn) || !isPlausibleIsoDate(endsOn)) return false;
  return endsOn >= startsOn;
}

/** Jour calendaire Europe/Paris (YYYY-MM-DD), pour ancrer le sélecteur de date. */
export function todayIso(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris" }).format(new Date());
}
